import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9510ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "Select App", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Subscriptions"),
    /*#__PURE__*/_createElementVNode("th", null, "URL"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-pencil-alt" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-check-circle text-success" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-times-circle text-danger" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus fa-fw me-2" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Add ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "webhookName",
  class: "form-label"
}, "ID", -1))
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "webhookName",
  class: "form-label"
}, "Name", -1))
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "webhookDescription",
  class: "form-label"
}, "Description", -1))
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "webhookUrl",
  class: "form-label"
}, "URL", -1))
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "webhookPreSharedKey",
  class: "form-label"
}, "Pre Shared Key", -1))
const _hoisted_39 = { class: "mb-3 table-types" }
const _hoisted_40 = { class: "table table-sm" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Label")
  ])
], -1))
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appId) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installedApps, (app, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: app.id
            }, " [" + _toDisplayString(app.id) + "] " + _toDisplayString(_ctx.availableApps[app.app_name].title) + "        " + _toDisplayString(app.clients.map((client) => client.clientName).join(', ')), 9, _hoisted_4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sprinklrExternalSystems, (system, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: system.id
            }, " [" + _toDisplayString(system.id) + "] " + _toDisplayString(system.name) + "        " + _toDisplayString(system.info.map((client) => client.value).join(', ')), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.appId]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhooks, (webhook, webhookIdx) => {
              return (_openBlock(), _createElementBlock("tr", { key: webhookIdx }, [
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.startEdit(webhookIdx))
                  }, _hoisted_11, 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger mt-3",
                    onClick: ($event: any) => (_ctx.startRemove(webhookIdx))
                  }, _hoisted_14, 8, _hoisted_12)
                ]),
                _createElementVNode("td", null, _toDisplayString(webhook.id), 1),
                _createElementVNode("td", null, _toDisplayString(webhook.name), 1),
                _createElementVNode("td", null, _toDisplayString(webhook.description), 1),
                _createElementVNode("td", null, _toDisplayString(webhook.subscriptions.join(', ')), 1),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(webhook.url), 1),
                  _hoisted_15,
                  _hoisted_16,
                  _createTextVNode(" Pre Shared Key: " + _toDisplayString(webhook.preSharedKey), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["far fa-fw status-icon fa-check cursor-pointer", webhook.verified ? 'text-success' : 'status-off']),
                    title: "Verified",
                    onClick: ($event: any) => (_ctx.verify(webhook.id))
                  }, null, 10, _hoisted_17),
                  (webhook.active)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "fa fa-fw status-icon fa-play cursor-pointer text-success",
                        title: "Active",
                        onClick: ($event: any) => (_ctx.deactivate(webhook.id))
                      }, null, 8, _hoisted_18))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "fa fa-fw status-icon fa-play cursor-pointer status-off",
                        title: "Active",
                        onClick: ($event: any) => (_ctx.activate(webhook.id))
                      }, null, 8, _hoisted_19)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["far fa-fw status-icon fa-globe", webhook.viaProxy ? 'text-success' : 'status-off']),
                    title: "Via Proxy"
                  }, null, 2),
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(webhook.lastSuccessTimestamp)), 1),
                  _hoisted_23,
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(webhook.lastFailedTimestamp)), 1),
                  _hoisted_25
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startNew && _ctx.startNew(...args)))
        }, _hoisted_28)
      ])
    ]),
    (_ctx.removeWebhook)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          title: "Remove Webhook",
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeWebhook = false)),
          onConfirm: _ctx.remove,
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Are you sure you want to remove the webhook " + _toDisplayString(_ctx.removeWebhook.name) + "? ", 1)
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.editWebhook)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          title: "Webhook",
          onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editWebhook = false)),
          onConfirm: _ctx.save,
          "min-width": "800px",
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", null, [
              (!_ctx.editWebhook.new)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "webhookName",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editWebhook.data.id) = $event)),
                      readonly: "",
                      disabled: "",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 512), [
                      [_vModelText, _ctx.editWebhook.data.id]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "webhookName",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editWebhook.data.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editWebhook.data.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "webhookDescription",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editWebhook.data.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editWebhook.data.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "webhookUrl",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editWebhook.data.url) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editWebhook.data.url]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "webhookPreSharedKey",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editWebhook.data.preSharedKey) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editWebhook.data.preSharedKey]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("table", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhookTypes, (type, typeIdx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: typeIdx,
                        onClick: _withModifiers(($event: any) => (
                                    _ctx.editWebhook.data.subscriptionsObject[type.type] =
                                        !_ctx.editWebhook.data.subscriptionsObject[type.type]
                                ), ["stop","prevent"]),
                        class: _normalizeClass({ active: _ctx.editWebhook.data.subscriptionsObject[type.type] })
                      }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.editWebhook.data.subscriptionsObject[type.type]) = $event)
                          }, null, 8, _hoisted_43), [
                            [_vModelCheckbox, _ctx.editWebhook.data.subscriptionsObject[type.type]]
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(type.category), 1),
                        _createElementVNode("td", null, _toDisplayString(type.label), 1)
                      ], 10, _hoisted_42))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}